import React, { useState } from 'react';
import { FormComponent, UiComponent } from 'components';
import { CollectionType, ICollection } from 'types';
import { CollectionQuery } from 'queries';
import useModal from 'hooks/useModal';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

interface Props {
  collection: ICollection | null;
}

function CollectionForm({ collection }: Props) {
  const { handleClose, handleAlert } = useModal();
  const { mutateAsync: create } = CollectionQuery.useCreate();
  const { mutateAsync: update } = CollectionQuery.useUpdate();
  const [organizationId, setOrganizationId] = useState<
    number | null | undefined
  >(collection?.organizationId);

  const handleSubmit = async (data: ICollection) => {
    if (!collection && !organizationId) {
      handleAlert('조직을 선택해주세요');
      return;
    }

    try {
      if (collection) {
        await update({
          ...data,
          id: collection.id,
        });
        toast.success('컬렉션이 수정되었습니다.');
      } else {
        await create({ ...data, organizationId: organizationId ?? null });
        toast.success('컬렉션이 등록되었습니다.');
      }
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
      return;
    } finally {
      handleClose();
    }
  };

  return (
    <FormComponent.Form
      css={{
        width: '50vw',
        '> input': { width: '100%' },
        '> textarea': { width: '100%' },
        '> p': { margin: '16px 0', fontWeight: '600' },
      }}
      submit={handleSubmit}
    >
      {!collection && (
        <>
          <p>조직</p>
          <FormComponent.OrganizationSelect
            permission="collection:create"
            value={organizationId}
            onChange={setOrganizationId}
          />
        </>
      )}
      <p>이름</p>
      <FormComponent.Input name="name" defaultValue={collection?.name} />
      <p>제목</p>
      <FormComponent.Input name="title" defaultValue={collection?.title} />
      <p>부제목</p>
      <FormComponent.Input
        name="subTitle"
        defaultValue={collection?.subTitle}
      />
      <p>유형</p>
      <FormComponent.Select
        name="type"
        defaultValue={collection?.type}
        options={[
          {
            name: '기본',
            value: CollectionType.DEFAULT,
          },
          {
            name: '메인배너',
            value: CollectionType.MAIN_BANNER,
          },
          {
            name: '싱글배너',
            value: CollectionType.SINGLE_BANNER,
          },
          {
            name: '그리드',
            value: CollectionType.GRID,
          },
          {
            name: '카드',
            value: CollectionType.CARD,
          },
        ]}
      />
      <div css={{ display: 'flex', justifyContent: 'flex-end' }}>
        <UiComponent.Button type="submit" variant="contained" color="primary">
          {collection === null ? '등록하기' : '수정하기'}
        </UiComponent.Button>
      </div>
    </FormComponent.Form>
  );
}

export default CollectionForm;
